import React, { useContext, useEffect } from 'react';
import Box from 'core/ui/Box';
import useActions from 'modules/map/useActions';
import Modules from 'modules';
import { useSelector } from 'react-redux';
import { sessionSelectors } from 'modules/session';
import LoaderSm from 'core/ui/LoaderSm';
import useSelectors from 'modules/map/useSelectors';
import { usersCalendarsModule } from 'modules/usersCalendars';
import usePullRefresh from 'core/usePullRefresh';
import { DashboardContext } from 'contexts';
import ScheduleSwipe from './ScheduleSwipe';
import ScheduleList from './ScheduleList';

export default () => {
  const { request } = useActions();
  const { refresh } = usePullRefresh();
  const calendarData = useSelectors(usersCalendarsModule, 'calendarData');
  const loadingWorkouts = useSelectors(usersCalendarsModule, 'loadingWorkouts');
  const user = useSelector((state) => sessionSelectors.getUser(state));

  const dashboardContext = useContext(DashboardContext);

  const getWorkoutsGroup = ({ next, newDate, recursive }) => {
    request({
      action: Modules.usersCalendars.actions.getCalendarGroupWorkouts,
      data: {
        startAt: newDate,
        endAt: newDate,
        next: next === true ? true : null,
        recursive: recursive === true ? true : null,
        onlyUserClass: true,
      },
    });
  };

  useEffect(() => {
    if (user && user.id) {
      getWorkoutsGroup({ next: true, newDate: dashboardContext?.currentDate, recursive: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, dashboardContext?.currentDate, request]);

  useEffect(() => {
    if (refresh) {
      getWorkoutsGroup({ next: true, newDate: dashboardContext?.currentDate, recursive: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  return (
    <>
      <Box>
        <ScheduleSwipe
          currentDate={dashboardContext?.currentDate}
          setCurrentDate={dashboardContext?.setCurrentDate}
          onNext={(nextDate) => {
            dashboardContext.setCurrentDate(nextDate);
            getWorkoutsGroup({ next: true, newDate: nextDate, recursive: true });
          }}
          onPrev={(nextDate) => {
            dashboardContext.setCurrentDate(nextDate);
            getWorkoutsGroup({ next: false, newDate: nextDate, recursive: true });
          }}
        />

        <Box display="flex" flexGrow="1" mb={3} justifyContent="center">
          <LoaderSm loading={loadingWorkouts} />
        </Box>

        <Box mb={3}>
          <ScheduleList calendarData={calendarData} loading={loadingWorkouts} />
        </Box>
      </Box>
    </>
  );
};
